import { Loader } from '@googlemaps/js-api-loader';
import memoize from 'lodash/memoize';

export const getMapsLoader = memoize(() => new Loader({
  apiKey: window.tz_globalConfigs.environmentConfigs.googleMapsApiKey,
  version: 'weekly',
}));
